// @mui material components
import Grid from "@mui/material/Grid";

// React components
import MDBox from "components/MDBox";
import CloseIcon from "@mui/icons-material/Close";

// React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";
import {styled} from "@mui/material/styles";

// Dashboard components
import * as React from "react";
import {useEffect, useState} from "react";
import {
  Badge,
  Button,
  Card,
  TextField,
  Tooltip,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import dayjs from "dayjs";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {PickersDay} from "@mui/x-date-pickers";
import {DayCalendarSkeleton} from "@mui/x-date-pickers/DayCalendarSkeleton";
import MDBadge from "components/MDBadge";
import {toast} from "react-toastify";
import {GET} from "APIclient";
import {useNavigate} from "react-router-dom";
import {Avatar, Divider} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import CustomCalendar from "./customCalendar";
import properties from "constants/ApplicationConstants";
import {PieChart, Pie, Cell, Legend, ResponsiveContainer} from "recharts";
import {formatDesignation} from "constants/ApplicationConstants";
import UpcomingWorkAnniversary from "./UpcomingWorkAnniversary";

const COLORS = ["#0088FE", "#00C49F"];
const COLORS_GENDER = ["#0088FE", "#FF69B4"];

const StyledBadge = styled(Badge)(({theme}) => ({
  "& .MuiBadge-badge": {
    right: 1,
    top: -2,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
    color: "error"
  }
}));

function getRandomNumber(min, max) {
  return Math.round(Math.random() * (max - min) + min);
}

let Login_routes = localStorage.getItem("login_response");
let nested_routes;
if (nested_routes) {
  nested_routes = Login_routes.jsonData;
  let modifiedArray = nested_routes.map(item => {
    return item ? item.toUpperCase() : item.items.join(", ");
  });
}

function fakeFetch(date, {signal}) {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      const daysInMonth = date.daysInMonth();
      const daysToHighlight = [1, 2].map(() => getRandomNumber(1, daysInMonth));
      resolve({daysToHighlight});
    }, 500);
    signal.onabort = () => {
      clearTimeout(timeout);
      reject(new DOMException("aborted", "AbortError"));
    };
  });
}

function ServerDay(props) {
  const {highlightedDays = [], day, outsideCurrentMonth, ...other} = props;
  const isSelected = !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.date()) >= 0;
  return (
    <Badge
      key={props.day.toString()}
      overlap="circular"
      color="error"
      badgeContent={isSelected ? "✓" : undefined}
    >
      <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
    </Badge>
  );
}

// ✅ MOVED OUTSIDE Dashboard function
// This prevents DraggableGridItem from being recreated on every Dashboard re-render
// which was causing CustomCalendar to unmount/remount and fire APIs repeatedly
const DraggableGridItem = ({id, children, gridProps, orderMap, defaultOrder, swapOrder}) => {
  const [draggableEnabled, setDraggableEnabled] = React.useState(false);

  const handleDragStart = e => {
    e.dataTransfer.setData("text/plain", id);
    e.dataTransfer.effectAllowed = "move";
  };
  const handleDragOver = e => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };
  const handleDrop = e => {
    e.preventDefault();
    const sourceId = e.dataTransfer.getData("text/plain");
    swapOrder(sourceId, id);
  };

  return (
    <Grid
      item
      {...gridProps}
      data-draggable="true"
      draggable={draggableEnabled}
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onDragEnd={() => setDraggableEnabled(false)}
      sx={{
        order: orderMap[id] ?? defaultOrder[id] ?? 0,
        position: "relative"
      }}
    >
      <Tooltip title="Drag">
        <IconButton
          size="small"
          sx={{
            position: "absolute",
            top: 12,
            left: 18,
            zIndex: 2,
            backgroundColor: "transparent",
            cursor: "grab",
            boxShadow: "none"
          }}
          aria-label="Drag card"
          onMouseDown={() => setDraggableEnabled(true)}
          onMouseUp={() => setDraggableEnabled(false)}
        >
          <DragIndicatorIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      {children}
    </Grid>
  );
};

function Dashboard() {
  const userType = JSON.parse(localStorage.getItem("userType"));
  const empId = window.sessionStorage.getItem("empId")
    ? Number(window.sessionStorage.getItem("empId"))
    : null;
  const initialValue = dayjs();
  const [value, setValue] = React.useState(new Date());
  const requestAbortController = React.useRef(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [highlightedDays, setHighlightedDays] = React.useState([2, 15]);
  const navigate = useNavigate();
  const [offerLetterCount, setOfferLetterCount] = useState(0);
  const [employeeCount, setEmployeeCount] = useState(0);
  const [probationCount, setProbationCount] = useState(0);
  const [appraisalCount, setPerformanceAppraisalCount] = useState(0);
  const [reportingEmployeeCount, setReportingEmployeeCount] = useState(0);
  const [pipData, setPipData] = useState([]);
  const [probationData, setProbationData] = useState([]);
  const [joiningData, setJoiningData] = useState([]);
  const [reportingData, setReportingData] = useState([]);
  const [employeeOnLeaves, setEmployeeOnLeaves] = useState([]);
  const [birthDayData, setBirthDayData] = useState([]);
  const [documentsPending, setDocumentsPending] = useState([]);
  const [uploadImgPending, setUploadImgPending] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [genderchartData, setgenderChartData] = useState([]);
  const [month, setMonth] = useState(dayjs().month() + 1);
  const [assetsCount, setAssetsCount] = useState(null);
  const [workstationsCount, setWorkstationsCount] = useState(null);
  const [kraRemainingCount, setKraRemainingCount] = useState(0);
  const [kraRemainingEmployees, setKraRemainingEmployees] = useState([]);
  const [kraDeadline, setKraDeadline] = useState(null);
  const [showKraPopup, setShowKraPopup] = useState(false);
  const [workAnniversaryData5, setWorkAnniversaryData5] = useState([]);
  const [workAnniversaryData10, setWorkAnniversaryData10] = useState([]);

  // ✅ Stable memoized calendar — won't remount on Dashboard re-renders
  const memoizedCalendar = React.useMemo(() => <CustomCalendar />, []);

  // Drag & Drop ordering state (persisted per userType)
  const persistedKey = React.useMemo(
    () => `dashboardOrder_${userType || "Unknown"}_${empId || "0"}`,
    [userType, empId]
  );

  const defaultOrder = React.useMemo(
    () => ({
      probation: 1,
      expectedJoinings: 2,
      pip: 3,
      reportingNotSet: 4,
      employeeOnLeaves: 5,
      birthday: 6,
      documentsPending: 7,
      uploadImgPending: 8,
      workAnniversary: 9,
      workAnniversary10: 10,
      employeeComposition: 11,
      billableNonBillable: 12,
      calendarBlock: 13
    }),
    []
  );

  const [orderMap, setOrderMap] = React.useState(defaultOrder);

  React.useEffect(() => {
    if (!userType) return;
    try {
      const saved = localStorage.getItem(persistedKey);
      if (saved) {
        const parsed = JSON.parse(saved);
        setOrderMap(prev => ({...prev, ...parsed}));
      }
    } catch (e) {}
  }, [persistedKey, userType, empId]);

  const saveOrder = React.useCallback(
    updated => {
      setOrderMap(updated);
      try {
        localStorage.setItem(persistedKey, JSON.stringify(updated));
      } catch (e) {}
    },
    [persistedKey]
  );

  const swapOrder = React.useCallback(
    (sourceId, targetId) => {
      if (!sourceId || !targetId || sourceId === targetId) return;
      setOrderMap(prev => {
        const next = {...prev};
        const a = next[sourceId] ?? 0;
        const b = next[targetId] ?? 0;
        next[sourceId] = b;
        next[targetId] = a;
        try {
          localStorage.setItem(persistedKey, JSON.stringify(next));
        } catch (e) {}
        return next;
      });
    },
    [persistedKey]
  );

  const isWeekend = date => {
    const day = date.day();
    return day === 0 || day === 6;
  };

  const fetchHighlightedDays = date => {
    const controller = new AbortController();
    fakeFetch(date, {signal: controller.signal})
      .then(({daysToHighlight}) => {
        setHighlightedDays(daysToHighlight);
        setIsLoading(false);
      })
      .catch(error => {
        if (error.name !== "AbortError") {
          throw error;
        }
      });
    requestAbortController.current = controller;
  };

  React.useEffect(() => {
    fetchHighlightedDays(initialValue);
    return () => requestAbortController.current?.abort();
  }, []);

  const handleMonthChange = date => {
    if (requestAbortController.current) {
      requestAbortController.current.abort();
    }
    setIsLoading(true);
    setHighlightedDays([]);
    fetchHighlightedDays(date);
  };

  const [leaveBalances, setLeaveBalances] = useState({
    plannedLeaves: 0,
    unplannedLeaves: 0,
    compensatoryLeaves: 0
  });

  useEffect(() => {
    if (empId) {
      const employeeLeavesUrl = `employee/remaining-leaves/${empId}`;
      const fetchLeavesData = async () => {
        try {
          const response = await GET(employeeLeavesUrl);
          if (response && response.data) {
            const {plannedLeaves, unplannedLeaves, coffLeaves} = response.data.data;
            setLeaveBalances({
              plannedLeaves: plannedLeaves,
              unplannedLeaves: unplannedLeaves,
              compensatoryLeaves: coffLeaves
            });
          }
        } catch (error) {
          console.error("Error fetching leave data:", error);
        }
      };
      fetchLeavesData();
    }
  }, [empId]);

  // API For Offer Letter Count
  useEffect(() => {
    if (userType === "Admin") {
      const fetchOfferLetterCount = async () => {
        try {
          const response = await GET("admin/get-offerLetter-count");
          if (response?.status === 200) setOfferLetterCount(response?.data?.data);
        } catch (error) {
          console.error("Error fetching offer letter count:", error);
        }
      };
      fetchOfferLetterCount();
    }
  }, [userType]);

  // API For Employee Count
  useEffect(() => {
    if (userType === "Admin") {
      const fetchEmployeeCount = async () => {
        try {
          const response = await GET("admin/get-employee-count");
          if (response?.status === 200) setEmployeeCount(response?.data?.data);
        } catch (error) {
          console.error("Error fetching employee count:", error);
        }
      };
      fetchEmployeeCount();
    }
  }, [userType]);

  // API For Probation Count
  useEffect(() => {
    if (userType === "Admin") {
      const fetchProbationEmpCount = async () => {
        try {
          const response = await GET("admin/get-probation-count");
          if (response?.status === 200) setProbationCount(response?.data?.data);
        } catch (error) {
          console.error("Error fetching probation count:", error);
        }
      };
      fetchProbationEmpCount();
    }
  }, [userType]);

  // API For Performance Appraisal Count
  useEffect(() => {
    if (userType === "Admin") {
      const fetchPerformanceAppraisalCount = async () => {
        try {
          const response = await GET("admin/get-performanceappraisal-count");
          if (response?.status === 200) setPerformanceAppraisalCount(response?.data?.data);
        } catch (error) {
          console.error("Error fetching appraisal count:", error);
        }
      };
      fetchPerformanceAppraisalCount();
    }
  }, [userType]);

  // API For Reporting Employees Count
  useEffect(() => {
    if (userType === "Manager" || userType === "IT_Admin_Manager") {
      const fetchReportingEmployeeCount = async () => {
        try {
          const response = await GET(`manager/get-reporting-count?empId=${empId}`);
          if (response?.status === 200) setReportingEmployeeCount(response?.data?.data);
        } catch (error) {
          console.error("Error fetching reporting count:", error);
        }
      };
      fetchReportingEmployeeCount();
    }
  }, [userType]);

  // API For PIP List
  useEffect(() => {
    const fetchPIPList = async () => {
      try {
        const baseUrl = "admin/get-pipList";
        const empIdNum = Number(window.sessionStorage.getItem("empId"));
        const url =
          userType === "Manager" || userType === "IT_Admin_Manager"
            ? `${baseUrl}?managerId=${empIdNum}`
            : baseUrl;
        const response = await GET(url);
        if (response?.status === 200) {
          const formatted = (response?.data?.data?.paginatedData || []).map(item => ({
            ...item,
            designation: formatDesignation(item?.designation)
          }));
          setPipData(formatted);
        }
      } catch (error) {
        console.error("Error fetching PIP list:", error);
      }
    };
    if (userType === "Admin" || userType === "Manager" || userType === "IT_Admin_Manager") {
      fetchPIPList();
    }
  }, [userType]);

  // API For KRA Remaining Employees
  useEffect(() => {
    if ((userType === "Manager" || userType === "IT_Admin_Manager") && empId) {
      const fetchKraRemainingEmployees = async () => {
        try {
          const appraisalResponse = await GET(`manager/appraisal/current`);
          if (appraisalResponse.data && appraisalResponse.data.data) {
            const appraisalData = appraisalResponse.data.data;
            setKraDeadline(appraisalData.formEditDeadline);
            const reporteesResponse = await GET(`manager/reportees/${empId}`);
            if (reporteesResponse.data && reporteesResponse.data.data) {
              const employeesData =
                reporteesResponse.data.data.paginatedData || reporteesResponse.data.data;
              const remainingEmployees = Array.isArray(employeesData)
                ? employeesData
                    .filter(
                      emp => emp?.applicableSkills?.length === 0 || emp?.applicableSkills == null
                    )
                    .map(emp => ({
                      empId: emp.empId,
                      firstName: emp.firstName || emp.first_name || "",
                      middleName: emp.middleName || emp.middle_name || "",
                      lastName: emp.lastName || emp.last_name || "",
                      designation: emp.designation || ""
                    }))
                : [];
              setKraRemainingEmployees(remainingEmployees);
              setKraRemainingCount(remainingEmployees.length);
              if (remainingEmployees.length > 0 && appraisalData.isOpen) {
                setShowKraPopup(true);
              }
            }
          }
        } catch (error) {
          console.error("Error fetching KRA remaining employees:", error);
          setKraRemainingCount(0);
        }
      };
      fetchKraRemainingEmployees();
    }
  }, [userType, empId]);

  // API For Remaining Probation List
  useEffect(() => {
    const fetchRemainingProbation = async () => {
      try {
        const baseUrl = "admin/get-remaining-probation";
        const empIdNum = Number(window.sessionStorage.getItem("empId"));
        const url =
          userType === "Manager" || userType === "IT_Admin_Manager"
            ? `${baseUrl}?empId=${empIdNum}`
            : baseUrl;
        const response = await GET(url);
        if (response?.status === 200) {
          const formatted = (response?.data?.data?.paginatedData || []).map(item => ({
            ...item,
            designation: formatDesignation(item?.designation)
          }));
          setProbationData(formatted);
        }
      } catch (error) {
        console.error("Error fetching remaining probation list:", error);
      }
    };
    if (userType === "Admin" || userType === "Manager" || userType === "IT_Admin_Manager") {
      fetchRemainingProbation();
    }
  }, [userType]);

  useEffect(() => {
    const fetchExpectedJoiningList = async () => {
      try {
        const response = await GET("admin/get-expectedJoiningList");
        if (response?.status === 200) {
          const formatted = (response?.data?.data?.paginatedData || []).map(item => ({
            ...item,
            designation: formatDesignation(item?.designation)
          }));
          setJoiningData(formatted);
        }
      } catch (error) {
        console.error("Error fetching expected joining list:", error);
      }
    };
    if (userType === "Admin") fetchExpectedJoiningList();
  }, [userType]);

  useEffect(() => {
    const fetchReportingManagerNotSetList = async () => {
      try {
        const response = await GET("admin/get-reporting-manager-notSet");
        if (response?.status === 200) {
          const formatted = (response?.data?.data?.paginatedData || []).map(item => ({
            ...item,
            designation: formatDesignation(item?.designation)
          }));
          setReportingData(formatted);
        }
      } catch (error) {
        console.error("Error fetching reporting manager not set list:", error);
      }
    };
    if (userType === "Admin") fetchReportingManagerNotSetList();
  }, [userType]);

  useEffect(() => {
    const fetchEmployeeOnLeaves = async () => {
      try {
        const baseUrl = "admin/get-employee-todayleaves";
        const empIdNum = Number(window.sessionStorage.getItem("empId"));
        const url =
          userType === "Manager" || userType === "IT_Admin_Manager"
            ? `${baseUrl}?empId=${empIdNum}`
            : baseUrl;
        const response = await GET(url);
        if (response?.status === 200) {
          setEmployeeOnLeaves(response.data.data.paginatedData || []);
        }
      } catch (error) {
        console.error("Error fetching employee on leaves:", error);
      }
    };
    if (userType === "Admin" || userType === "Manager" || userType === "IT_Admin_Manager") {
      fetchEmployeeOnLeaves();
    }
  }, [userType]);

  useEffect(() => {
    const fetchBirthDayList = async monthNumber => {
      try {
        const response = await GET(
          `admin/get-employee-birthDay?page=0&size=10&month=${monthNumber}`
        );
        if (response?.status === 200) {
          const formatted = (response?.data?.data?.paginatedData || []).map(item => ({
            ...item,
            designation: formatDesignation(item?.designation)
          }));
          setBirthDayData(formatted);
        } else {
          setBirthDayData([]);
        }
      } catch (error) {
        console.error("Error fetching birthday data:", error);
        setBirthDayData([]);
      }
    };
    if (userType === "Admin" && month) fetchBirthDayList(month);
  }, [userType, month]);

  useEffect(() => {
    const fetchDocumentsPendingList = async () => {
      try {
        const response = await GET("admin/get-missing-doc");
        if (response?.status === 200) {
          const formatted = (response?.data?.data?.paginatedData || []).map(item => ({
            ...item,
            designation: formatDesignation(item?.designation)
          }));
          setDocumentsPending(formatted);
        }
      } catch (error) {
        console.error("Error fetching documents pending list:", error);
      }
    };
    if (userType === "Admin") fetchDocumentsPendingList();
  }, [userType]);

  useEffect(() => {
    const fetchUploadImgPendingList = async () => {
      try {
        const response = await GET("admin/image-pending");
        if (response?.status === 200) {
          const formatted = (response?.data?.data?.paginatedData || []).map(item => ({
            ...item,
            designation: formatDesignation(item?.designation)
          }));
          setUploadImgPending(formatted);
        }
      } catch (error) {
        console.error("Error fetching upload image pending list:", error);
      }
    };
    if (userType === "Admin") fetchUploadImgPendingList();
  }, [userType]);

  useEffect(() => {
    const fetchBillableData = async () => {
      try {
        const response = await GET("admin/billableNonBillable");
        const list = response?.data?.data?.paginatedData;
        const uniqueEmployees = new Map();
        list.forEach(emp => {
          const key = `${emp.employeeId}_${emp.chargeability}`;
          if (!uniqueEmployees.has(key)) uniqueEmployees.set(key, emp.chargeability);
        });
        const counts = {billable: 0, nonBillable: 0};
        for (const charge of uniqueEmployees.values()) {
          if (charge === 1) counts.billable += 1;
          else if (charge === 2) counts.nonBillable += 1;
        }
        setChartData([
          {name: "Billable", value: counts.billable},
          {name: "Non-Billable", value: counts.nonBillable}
        ]);
      } catch (error) {
        console.error("Error fetching billable/non-billable data", error);
      }
    };
    if (userType === "Admin") fetchBillableData();
  }, [userType]);

  useEffect(() => {
    const fetchGenderCounts = async () => {
      try {
        const [maleRes, femaleRes] = await Promise.all([
          GET("admin/get-male-employee-count"),
          GET("admin/get-female-employee-count")
        ]);
        const maleCount = maleRes?.data?.data ?? 0;
        const femaleCount = femaleRes?.data?.data ?? 0;
        setgenderChartData([
          {name: "Male", value: maleCount},
          {name: "Female", value: femaleCount}
        ]);
      } catch (error) {
        console.error("Error fetching employee gender data", error);
      }
    };
    fetchGenderCounts();
  }, [userType]);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [assetsRes, workstationsRes] = await Promise.all([
          GET("it-dept/assets-count?status=true"),
          GET("it-dept/workstations-count?status=true")
        ]);
        setAssetsCount(Number(assetsRes.data?.data ?? 0));
        setWorkstationsCount(Number(workstationsRes.data?.data ?? 0));
      } catch (error) {
        console.error("Error fetching counts:", error);
        setAssetsCount(0);
        setWorkstationsCount(0);
      }
    };
    fetchCounts();
  }, []);

  useEffect(() => {
    const formatAnniversaryData = data =>
      (data || []).map(item => ({
        ...item,
        designation: formatDesignation(item?.designation)
      }));

    const fetchWorkAnniversaryByMilestone = async (milestoneYears, setter) => {
      try {
        const response = await GET(
          `admin/get-employee-work-anniversary?milestoneYears=${milestoneYears}&page=0&size=10`
        );

        if (response?.status === 200) {
          setter(formatAnniversaryData(response?.data?.data?.paginatedData));
        } else {
          setter([]);
        }
      } catch (error) {
        console.error(`Error fetching ${milestoneYears} year work anniversary data:`, error);
        setter([]);
      }
    };

    if (userType === "Admin") {
      fetchWorkAnniversaryByMilestone(5, setWorkAnniversaryData5);
      fetchWorkAnniversaryByMilestone(10, setWorkAnniversaryData10);
    }
  }, [userType]);

  const commonBoxStyles = {
    mb: 3,
    p: 2.5,
    bgColor: "white",
    boxShadow: "0 6px 24px rgba(24, 54, 122, 0.10)",
    sx: {
      height: "400px",
      borderRadius: "16px",
      background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
      border: "1px solid rgba(24, 54, 122, 0.08)",
      transition: "transform 0.25s ease, box-shadow 0.25s ease",
      "&:hover": {
        transform: "translateY(-3px)",
        boxShadow: "0 12px 32px rgba(24, 54, 122, 0.14)"
      },
      "&::-webkit-scrollbar": {width: "4px", height: "4px"},
      "&::-webkit-scrollbar-track": {background: "transparent"},
      "&::-webkit-scrollbar-thumb": {
        background: "linear-gradient(180deg, #53B0E0, #18367A)",
        borderRadius: "10px",
        "&:hover": {background: "#18367A"}
      },
      "&::-webkit-scrollbar-button": {display: "none", height: 0, width: 0}
    }
  };

  const commonScrollStyles = {
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(24, 54, 122, 0.35) transparent",
    "&::-webkit-scrollbar": {width: "4px"},
    "&::-webkit-scrollbar-track": {background: "transparent"},
    "&::-webkit-scrollbar-thumb": {
      background: "linear-gradient(180deg, #53B0E0, #18367A)",
      borderRadius: "10px"
    },
    "&::-webkit-scrollbar-button": {display: "none", height: 0, width: 0}
  };

  const commonTypographyStyles = {fontFamily: properties.fontFamily};

  const commonHeaderStyles = {
    variant: "h6",
    fontFamily: properties.fontFamily,
    fontWeight: "bold",
    color: "#093396",
    mb: 1,
    sx: {
      fontSize: "1rem",
      letterSpacing: "0.1px",
      borderBottom: "none",
      paddingBottom: "8px",
      marginBottom: "16px",
      display: "inline-block",
      position: "relative",
      "&::after": {
        content: '""',
        position: "absolute",
        left: 0,
        bottom: 0,
        width: "100%",
        height: "3px",
        borderRadius: "999px",
        background: "linear-gradient(90deg, #53B0E0, #18367A)"
      }
    }
  };

  const commonCountBadgeStyles = {
    ml: 2,
    background: "linear-gradient(135deg, #53B0E0, #18367A)",
    borderRadius: "20px",
    px: 1.5,
    py: 0.4,
    fontSize: "0.85rem",
    fontWeight: 600,
    boxShadow: "0 2px 8px rgba(24, 54, 122, 0.25)"
  };

  const commonIdBadgeStyles = {
    backgroundColor: "rgba(24, 54, 122, 0.08)",
    padding: "4px 10px",
    borderRadius: "18px",
    border: "1px solid rgba(24, 54, 122, 0.08)",
    display: "inline-flex",
    alignItems: "center",
    "& .MuiTypography-root": {
      fontSize: "0.82rem",
      lineHeight: 1.3,
      fontWeight: 500,
      color: "#18367A",
      fontFamily: properties.fontFamily
    }
  };

  const commonListItemStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: 1.75,
    mb: 1,
    borderRadius: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid rgba(24, 54, 122, 0.06)",
    boxShadow: "0 1px 4px rgba(24, 54, 122, 0.05)",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-1px)",
      borderColor: "rgba(24, 54, 122, 0.18)",
      backgroundColor: "rgba(24, 54, 122, 0.03)",
      boxShadow: "0 4px 12px rgba(24, 54, 122, 0.08)"
    }
  };

  const commonNoDataStyles = {
    textAlign: "center",
    color: "text.secondary",
    mt: 4,
    p: 2,
    borderRadius: "12px",
    backgroundColor: "rgba(0, 0, 0, 0.02)",
    border: "1px dashed rgba(0, 0, 0, 0.1)",
    sx: {fontSize: "0.875rem", fontStyle: "italic"}
  };

  const commonDividerStyles = {my: 1};

  const KraRemainingPopup = () => (
    <Dialog open={showKraPopup} onClose={() => setShowKraPopup(false)} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          background: properties.colors.bgcolorbluethem,
          color: "white",
          py: 1,
          px: 1.5,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <MDBox>
          <MDTypography variant="h5" color="white" fontWeight="medium">
            KRA Assign Pending
          </MDTypography>
          <MDTypography variant="caption" color="white" sx={{fontSize: "1rem"}}>
            {kraRemainingCount} employee{kraRemainingCount !== 1 ? "s" : ""} remaining
          </MDTypography>
        </MDBox>
        <IconButton onClick={() => setShowKraPopup(false)} sx={{color: "white"}} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{p: 1.5}}>
        {kraDeadline && (
          <MDTypography
            variant="body2"
            color="black"
            fontWeight="bold"
            sx={{display: "block", fontSize: "1rem", py: 1, mb: 1}}
          >
            KRA Assign Window Open:{" "}
            {new Date(kraDeadline).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric"
            })}
          </MDTypography>
        )}
        <Grid container spacing={1} sx={{backgroundColor: "#f5f5f5", py: 0.75, px: 1, mb: 0.5}}>
          <Grid item xs={0.8}>
            <MDTypography variant="body2" fontWeight="bold" sx={{fontSize: "0.85rem"}}>
              #
            </MDTypography>
          </Grid>
          <Grid item xs={2.2}>
            <MDTypography variant="body2" fontWeight="bold" sx={{fontSize: "0.85rem"}}>
              Employee ID
            </MDTypography>
          </Grid>
          <Grid item xs={5}>
            <MDTypography variant="body2" fontWeight="bold" sx={{fontSize: "0.85rem"}}>
              Name
            </MDTypography>
          </Grid>
          <Grid item xs={4}>
            <MDTypography variant="body2" fontWeight="bold" sx={{fontSize: "0.85rem"}}>
              Designation
            </MDTypography>
          </Grid>
        </Grid>
        <MDBox sx={{maxHeight: "400px", overflowY: "auto"}}>
          {kraRemainingEmployees.length > 0 ? (
            kraRemainingEmployees.map((emp, index) => (
              <Grid
                key={emp.empId}
                container
                spacing={1}
                sx={{
                  py: 0.75,
                  px: 1,
                  backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                  "&:hover": {backgroundColor: "#f0f0f0"}
                }}
              >
                <Grid item xs={0.8}>
                  <MDTypography variant="body2" sx={{fontSize: "0.85rem", color: "#000"}}>
                    {index + 1}
                  </MDTypography>
                </Grid>
                <Grid item xs={2.2}>
                  <MDTypography variant="body2" sx={{fontSize: "0.85rem", color: "#000"}}>
                    {emp.empId}
                  </MDTypography>
                </Grid>
                <Grid item xs={5}>
                  <MDTypography variant="body2" sx={{fontSize: "0.85rem", color: "#000"}}>
                    {`${emp.firstName} ${emp.middleName || ""} ${emp.lastName}`.trim()}
                  </MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDTypography variant="body2" sx={{fontSize: "0.85rem", color: "#000"}}>
                    {emp.designation ? formatDesignation(emp.designation) : "-"}
                  </MDTypography>
                </Grid>
              </Grid>
            ))
          ) : (
            <MDBox sx={{py: 2, textAlign: "center"}}>
              <MDTypography variant="body2" color="text.secondary" sx={{fontSize: "0.85rem"}}>
                No employees pending KRA assignment
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
        <MDBox display="flex" justifyContent="flex-end" mt={1.5} gap={1}>
          <MDButton
            variant="outlined"
            color="secondary"
            size="small"
            onClick={() => setShowKraPopup(false)}
          >
            Close
          </MDButton>
          <MDButton
            variant="gradient"
            color="info"
            size="small"
            onClick={() => {
              setShowKraPopup(false);
              handleAssignKRAClick();
            }}
            sx={{background: properties.colors.bgcolorbluethem}}
          >
            Assign KRA
          </MDButton>
        </MDBox>
      </DialogContent>
    </Dialog>
  );

  const ProbationEndList = ({probationData = []}) => (
    <MDBox {...commonBoxStyles}>
      <MDBox display="flex" alignItems="center" mb={1} justifyContent="space-between">
        <MDTypography {...commonHeaderStyles}>Probation End List</MDTypography>
        <MDBox
          color="white"
          sx={commonCountBadgeStyles}
        >
          {probationData.length}
        </MDBox>
      </MDBox>
      <Divider sx={commonDividerStyles} />
      <MDBox sx={{height: "calc(100% - 80px)", ...commonScrollStyles}}>
        {probationData.length > 0 ? (
          probationData.map((item, index) => (
            <MDBox
              key={index}
              sx={{
                ...commonListItemStyles
              }}
            >
              <MDBox display="flex" alignItems="center">
                <MDBox lineHeight={0.7}>
                  <MDTypography
                    variant="subtitle2"
                    fontWeight="medium"
                    sx={{color: "#18367A", fontFamily: properties.fontFamily, mb: 0.5}}
                  >
                    {`${item.firstName || "N/A"} ${item.lastName || ""}`}
                  </MDTypography>
                  <MDTypography
                    variant="caption"
                    color="text.secondary"
                    sx={{fontSize: "0.85rem", fontFamily: properties.fontFamily}}
                  >
                    {item.designation ? item.designation.replace(/_/g, " ") : "N/A"}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox
                sx={commonIdBadgeStyles}
              >
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    color: "#18367A",
                    fontFamily: properties.fontFamily,
                    fontWeight: "medium"
                  }}
                >
                  {item.probationEndDate
                    ? dayjs(item.probationEndDate).format("DD MMM YYYY")
                    : "N/A"}
                </MDTypography>
              </MDBox>
            </MDBox>
          ))
        ) : (
          <MDTypography {...commonNoDataStyles}>No data to display.</MDTypography>
        )}
      </MDBox>
    </MDBox>
  );

  const ExpectedJoiningsList = ({joiningData = []}) => (
    <MDBox {...commonBoxStyles}>
      <MDBox display="flex" alignItems="center" mb={1} justifyContent="space-between">
        <MDTypography {...commonHeaderStyles}>Expected Joinings List</MDTypography>
        <MDBox
          color="white"
          sx={commonCountBadgeStyles}
        >
          {joiningData.length}
        </MDBox>
      </MDBox>
      <MDTypography
        variant="caption"
        sx={{
          color: "text.secondary",
          display: "block",
          fontStyle: "italic",
          fontFamily: properties.fontFamily
        }}
      >
        (Within 7 Days)
      </MDTypography>
      <Divider sx={commonDividerStyles} />
      <MDBox sx={{height: "calc(100% - 80px)", ...commonScrollStyles}}>
        {joiningData.length > 0 ? (
          joiningData.map((item, index) => (
            <MDBox
              key={index}
              sx={{
                ...commonListItemStyles
              }}
            >
              <MDBox display="flex" alignItems="center">
                <MDBox lineHeight={0.7}>
                  <MDTypography
                    variant="subtitle2"
                    fontWeight="medium"
                    sx={{color: "#18367A", fontFamily: properties.fontFamily, mb: 0.5}}
                  >
                    {item?.employeeName || "N/A"}
                  </MDTypography>
                  <MDTypography
                    variant="caption"
                    color="text.secondary"
                    sx={{fontSize: "0.85rem", ...commonTypographyStyles}}
                  >
                    {item.designation ? item.designation.replace(/_/g, " ") : "N/A"}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox
                sx={commonIdBadgeStyles}
              >
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    color: "#18367A",
                    fontFamily: properties.fontFamily,
                    fontWeight: "medium"
                  }}
                >
                  {item?.joinDate ? dayjs(item?.joinDate).format("DD MMM YYYY") : "N/A"}
                </MDTypography>
              </MDBox>
            </MDBox>
          ))
        ) : (
          <MDTypography {...commonNoDataStyles}>No data to display</MDTypography>
        )}
      </MDBox>
    </MDBox>
  );

  const PIPList = ({pipData = []}) => (
    <MDBox {...commonBoxStyles}>
      <MDBox display="flex" alignItems="center" mb={1} justifyContent="space-between">
        <MDTypography {...commonHeaderStyles}>PIP List</MDTypography>
        <MDBox
          color="white"
          sx={commonCountBadgeStyles}
        >
          {pipData.length}
        </MDBox>
      </MDBox>
      <Divider sx={commonDividerStyles} />
      <MDBox sx={{height: "calc(100% - 80px)", ...commonScrollStyles}}>
        {pipData.length > 0 ? (
          pipData.map((item, index) => (
            <MDBox
              key={index}
              sx={{
                ...commonListItemStyles
              }}
            >
              <MDBox display="flex" alignItems="center">
                <MDBox lineHeight={0.7}>
                  <MDTypography
                    variant="subtitle2"
                    fontWeight="medium"
                    sx={{color: "#18367A", fontFamily: properties.fontFamily, mb: 0.5}}
                  >
                    {`${item.firstName || "N/A"} ${item.lastName || ""}`}
                  </MDTypography>
                  <MDTypography
                    variant="caption"
                    color="text.secondary"
                    sx={{fontSize: "0.85rem", ...commonTypographyStyles}}
                  >
                    {item.designation ? item.designation.replace(/_/g, " ") : "N/A"}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox
                sx={commonIdBadgeStyles}
              >
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    color: "#18367A",
                    fontFamily: properties.fontFamily,
                    fontWeight: "medium"
                  }}
                >
                  {item.pipEndDate ? dayjs(item.pipEndDate).format("DD MMM YYYY") : "N/A"}
                </MDTypography>
              </MDBox>
            </MDBox>
          ))
        ) : (
          <MDTypography {...commonNoDataStyles}>No data to display.</MDTypography>
        )}
      </MDBox>
    </MDBox>
  );

  const ReportingManagerNotSetList = ({reportingData = []}) => (
    <MDBox {...commonBoxStyles}>
      <MDBox display="flex" alignItems="center" mb={1} justifyContent="space-between">
        <MDTypography {...commonHeaderStyles}>Reporting Manager Not Set</MDTypography>
        <MDBox
          color="white"
          sx={commonCountBadgeStyles}
        >
          {reportingData.length}
        </MDBox>
      </MDBox>
      <Divider sx={commonDividerStyles} />
      <MDBox sx={{height: "calc(100% - 80px)", ...commonScrollStyles}}>
        {reportingData.length > 0 ? (
          reportingData.map((item, index) => (
            <MDBox
              key={index}
              sx={{
                ...commonListItemStyles
              }}
            >
              <MDBox display="flex" alignItems="center">
                <MDBox lineHeight={0.7}>
                  <MDTypography
                    variant="subtitle2"
                    fontWeight="medium"
                    sx={{color: "#18367A", fontFamily: properties.fontFamily, mb: 0.5}}
                  >
                    {`${item?.empName || "N/A"}`}
                  </MDTypography>
                  <MDTypography
                    variant="caption"
                    color="text.secondary"
                    sx={{fontSize: "0.85rem", ...commonTypographyStyles}}
                  >
                    {item?.designation ? item.designation.replace(/_/g, " ") : "N/A"}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox
                sx={commonIdBadgeStyles}
              >
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    color: "#18367A",
                    fontFamily: properties.fontFamily,
                    fontWeight: "medium"
                  }}
                >
                  {item.joinDate ? dayjs(item.joinDate).format("DD MMM YYYY") : "N/A"}
                </MDTypography>
              </MDBox>
            </MDBox>
          ))
        ) : (
          <MDTypography {...commonNoDataStyles}>No data to display.</MDTypography>
        )}
      </MDBox>
    </MDBox>
  );

  const EmployeeOnLeaves = ({employeeOnLeaves = []}) => {
    const getLeaveType = item => {
      if (item.plannedLeave > 0) return "Planned Leave";
      if (item.unplannedLeave > 0) return "Unplanned Leave";
      if (item.maternityLeave > 0) return "Maternity Leave";
      if (item.paternityLeave > 0) return "Paternity Leave";
      if (item.coffLeave > 0) return "Compensatory Leave";
      if (item.otherLeave > 0) return "LWP Leave";
      if (item.onsiteLeave > 0) return "Onsite Leave";
      return "N/A";
    };
    return (
      <MDBox {...commonBoxStyles}>
        <MDBox display="flex" alignItems="center" mb={1} justifyContent="space-between">
          <MDTypography {...commonHeaderStyles}>Employee On Leaves</MDTypography>
          <MDBox
            color="white"
            sx={commonCountBadgeStyles}
          >
            {employeeOnLeaves.length}
          </MDBox>
        </MDBox>
        <Divider sx={commonDividerStyles} />
        <MDBox sx={{height: "calc(100% - 80px)", ...commonScrollStyles}}>
          {employeeOnLeaves.length > 0 ? (
            employeeOnLeaves.map((item, index) => (
              <MDBox
                key={index}
                sx={{
                  ...commonListItemStyles
                }}
              >
                <MDBox display="flex" alignItems="center">
                  <MDBox lineHeight={0.7}>
                    <MDTypography
                      variant="subtitle2"
                      fontWeight="medium"
                      sx={{color: "#18367A", fontFamily: properties.fontFamily, mb: 0.5}}
                    >
                      {`${item?.empName || "N/A"}`}
                    </MDTypography>
                    <MDTypography
                      variant="caption"
                      color="text.secondary"
                      sx={{fontSize: "0.85rem", ...commonTypographyStyles}}
                    >
                      {getLeaveType(item)}
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox
                  sx={commonIdBadgeStyles}
                >
                  <MDTypography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      color: "#18367A",
                      fontFamily: properties.fontFamily,
                      fontWeight: "medium"
                    }}
                  >
                    {item?.empId ? item?.empId : "N/A"}
                  </MDTypography>
                </MDBox>
              </MDBox>
            ))
          ) : (
            <MDTypography {...commonNoDataStyles}>No data to display.</MDTypography>
          )}
        </MDBox>
      </MDBox>
    );
  };

  const BirthDayList = ({birthDayData = [], month, setMonth}) => (
    <MDBox {...commonBoxStyles}>
      <MDBox display="flex" alignItems="center" mb={1} justifyContent="space-between">
        <MDTypography {...commonHeaderStyles}>Birthday List</MDTypography>
        <Select
          value={month}
          onChange={e => setMonth(Number(e.target.value))}
          sx={{
            minWidth: 120,
            mb: 2,
            height: 35,
            borderRadius: "8px",
            border: "1px solid #18367A",
            backgroundColor: "#F0F4FF",
            color: "#18367A",
            fontWeight: 500,
            "& .MuiSelect-select": {padding: "10px 10px"}
          }}
        >
          <MenuItem value="">
            <em>Select</em>
          </MenuItem>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(m => (
            <MenuItem key={m} value={m}>
              {dayjs()
                .month(m - 1)
                .format("MMMM")}
            </MenuItem>
          ))}
        </Select>
      </MDBox>
      <Divider sx={commonDividerStyles} />
      <MDBox sx={{height: "calc(100% - 60px)", ...commonScrollStyles}}>
        {Array.isArray(birthDayData) && birthDayData.length > 0 ? (
          birthDayData.map((item, index) => (
            <MDBox
              key={index}
              sx={{
                ...commonListItemStyles
              }}
            >
              <MDBox display="flex" alignItems="center">
                <MDBox lineHeight={0.7}>
                  <MDTypography
                    variant="subtitle2"
                    fontWeight="medium"
                    sx={{color: "#18367A", fontFamily: properties.fontFamily, mb: 0.5}}
                  >
                    {item?.empName || "N/A"}
                  </MDTypography>
                  <MDTypography
                    variant="caption"
                    color="text.secondary"
                    sx={{fontSize: "0.85rem", ...commonTypographyStyles}}
                  >
                    {item?.designation ? item.designation.replace(/_/g, " ") : "N/A"}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox
                sx={commonIdBadgeStyles}
              >
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    color: "#18367A",
                    fontFamily: properties.fontFamily,
                    fontWeight: "medium"
                  }}
                >
                  {item?.birthDate ? dayjs(item?.birthDate).format("DD MMM YYYY") : "N/A"}
                </MDTypography>
              </MDBox>
            </MDBox>
          ))
        ) : (
          <MDTypography {...commonNoDataStyles}>No data to display.</MDTypography>
        )}
      </MDBox>
    </MDBox>
  );

  const DocumentsPendingList = ({documentsPending = []}) => (
    <MDBox {...commonBoxStyles}>
      <MDBox display="flex" alignItems="center" mb={1} justifyContent="space-between">
        <MDTypography {...commonHeaderStyles}>Documents Upload Pending List</MDTypography>
        <MDBox
          color="white"
          sx={commonCountBadgeStyles}
        >
          {documentsPending.length}
        </MDBox>
      </MDBox>
      <Divider sx={commonDividerStyles} />
      <MDBox sx={{height: "calc(100% - 80px)", ...commonScrollStyles}}>
        {documentsPending.length > 0 ? (
          documentsPending.map((item, index) => (
            <MDBox
              key={index}
              sx={{
                ...commonListItemStyles
              }}
            >
              <MDBox display="flex" alignItems="center">
                <MDBox lineHeight={0.7}>
                  <MDTypography
                    variant="subtitle2"
                    fontWeight="medium"
                    sx={{color: "#18367A", fontFamily: properties.fontFamily, mb: 0.5}}
                  >
                    {item?.empName || "N/A"}
                  </MDTypography>
                  <MDTypography
                    variant="caption"
                    color="text.secondary"
                    sx={{fontSize: "0.85rem", ...commonTypographyStyles}}
                  >
                    {item?.designation ? item.designation.replace(/_/g, " ") : "N/A"}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox
                sx={commonIdBadgeStyles}
              >
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    color: "#18367A",
                    fontFamily: properties.fontFamily,
                    fontWeight: "medium"
                  }}
                >
                  {item?.empId ? item?.empId : "N/A"}
                </MDTypography>
              </MDBox>
            </MDBox>
          ))
        ) : (
          <MDTypography {...commonNoDataStyles}>No data to display.</MDTypography>
        )}
      </MDBox>
    </MDBox>
  );

  const UploadImgPendingList = ({uploadImgPending = []}) => (
    <MDBox {...commonBoxStyles}>
      <MDBox display="flex" alignItems="center" mb={1} justifyContent="space-between">
        <MDTypography {...commonHeaderStyles}>Upload Image Pending List</MDTypography>
        <MDBox
          color="white"
          sx={commonCountBadgeStyles}
        >
          {uploadImgPending.length}
        </MDBox>
      </MDBox>
      <Divider sx={commonDividerStyles} />
      <MDBox sx={{height: "calc(100% - 80px)", ...commonScrollStyles}}>
        {uploadImgPending.length > 0 ? (
          uploadImgPending.map((item, index) => (
            <MDBox
              key={index}
              sx={{
                ...commonListItemStyles
              }}
            >
              <MDBox display="flex" alignItems="center">
                <MDBox lineHeight={0.7}>
                  <MDTypography
                    variant="subtitle2"
                    fontWeight="medium"
                    sx={{color: "#18367A", fontFamily: properties.fontFamily, mb: 0.5}}
                  >
                    {item?.empName || "N/A"}
                  </MDTypography>
                  <MDTypography
                    variant="caption"
                    color="text.secondary"
                    sx={{fontSize: "0.85rem", ...commonTypographyStyles}}
                  >
                    {item?.designation ? item.designation.replace(/_/g, " ") : "N/A"}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox
                sx={commonIdBadgeStyles}
              >
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    color: "#18367A",
                    fontFamily: properties.fontFamily,
                    fontWeight: "medium"
                  }}
                >
                  {item?.empId ? item?.empId : "N/A"}
                </MDTypography>
              </MDBox>
            </MDBox>
          ))
        ) : (
          <MDTypography {...commonNoDataStyles}>No data to display.</MDTypography>
        )}
      </MDBox>
    </MDBox>
  );

  const BillableNonBillable = () => (
    <MDBox {...commonBoxStyles}>
      <MDTypography {...commonHeaderStyles}>Billable Non-Billable</MDTypography>
      <Divider sx={commonDividerStyles} />
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            outerRadius={70}
            label={({name, percent, x, y}) => (
              <text x={x} y={y - 10} dominantBaseline="central" fontSize={11}>
                {`${name} ${(percent * 100).toFixed(0)}%`}
              </text>
            )}
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </MDBox>
  );

  const EmployeeComposition = () => (
    <MDBox {...commonBoxStyles}>
      <MDTypography {...commonHeaderStyles}>Employee Composition</MDTypography>
      <Divider sx={commonDividerStyles} />
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={genderchartData}
            cx="50%"
            cy="50%"
            outerRadius={70}
            label={({name, percent, x, y}) => (
              <text x={x} y={y - 10} dominantBaseline="central" fontSize={11}>
                {`${name} ${(percent * 100).toFixed(0)}%`}
              </text>
            )}
            dataKey="value"
          >
            {genderchartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS_GENDER[index % COLORS_GENDER.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </MDBox>
  );

  const handleOfferLetterClick = () => navigate("/Offer_List");
  const handleProbationPendingClick = () => navigate("/employeeProbationReports");
  const handleEmployeeClick = () => navigate("/Employee_List");
  const handleReportingEmployeesClick = () => navigate("/reporting-employees-list");
  const handleAssignKRAClick = () => navigate("/manager/appraisal/assign");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} px={1.5}>
        {userType !== "Admin" && (
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              md={6}
              lg={3}
              sx={{
                display: userType === "Manager" || userType === "IT_Admin_Manager" ? "" : "none"
              }}
            >
              <MDBox mb={1.5} onClick={handleReportingEmployeesClick} sx={{cursor: "pointer"}}>
                <ComplexStatisticsCard
                  icon="groups"
                  title="Reporting Employees"
                  count={reportingEmployeeCount}
                  percentage={{color: "success"}}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="info"
                  icon="weekend"
                  title="Planned Leaves"
                  count={leaveBalances.plannedLeaves}
                  percentage={{color: "success"}}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  icon="leaderboard"
                  title="Unplanned Leaves"
                  count={leaveBalances.unplannedLeaves}
                  percentage={{color: "success"}}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="info"
                  icon="store"
                  title="C-OFF Leaves"
                  count={leaveBalances.compensatoryLeaves}
                  percentage={{color: "success"}}
                />
              </MDBox>
            </Grid>
            {(userType === "Manager" || userType === "IT_Admin_Manager") && (
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5} onClick={handleAssignKRAClick} sx={{cursor: "pointer"}}>
                  <ComplexStatisticsCard
                    icon="assignment"
                    title="KRA Assign Pending"
                    count={kraRemainingCount}
                  />
                </MDBox>
              </Grid>
            )}
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  icon="public"
                  title="Global Information"
                  count="--"
                  percentage={{color: "success"}}
                />
              </MDBox>
            </Grid>
            {(userType === "IT_Admin_Manager" || userType === "IT_Admin_Employee") && (
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="info"
                    icon="inventory"
                    title="Assets"
                    count={assetsCount ?? "--"}
                    percentage={{color: "success"}}
                  />
                </MDBox>
              </Grid>
            )}
          </Grid>
        )}

        {userType === "Admin" && (
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={6}
              lg={3}
              sx={{
                display: JSON.parse(localStorage.getItem("userType")) === "Admin" ? "block" : "none"
              }}
            >
              <MDBox mb={1.5} onClick={handleOfferLetterClick} sx={{cursor: "pointer"}}>
                <ComplexStatisticsCard
                  icon="description"
                  title="Open Offer Letter"
                  count={offerLetterCount}
                  percentage={{color: "success"}}
                />
              </MDBox>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={3}
              sx={{
                display: JSON.parse(localStorage.getItem("userType")) === "Admin" ? "block" : "none"
              }}
            >
              <MDBox mb={1.5} onClick={handleProbationPendingClick} sx={{cursor: "pointer"}}>
                <ComplexStatisticsCard
                  icon="hourglass_empty"
                  title="Probation Pending"
                  count={probationCount}
                  percentage={{color: "success"}}
                />
              </MDBox>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={3}
              sx={{
                display: JSON.parse(localStorage.getItem("userType")) === "Admin" ? "block" : "none"
              }}
            >
              <MDBox mb={1.5} onClick={handleEmployeeClick} sx={{cursor: "pointer"}}>
                <ComplexStatisticsCard
                  icon="groups"
                  title="Employees"
                  count={employeeCount}
                  percentage={{color: "success"}}
                />
              </MDBox>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={3}
              sx={{
                display: JSON.parse(localStorage.getItem("userType")) === "Admin" ? "block" : "none"
              }}
            >
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  icon="assessment"
                  title="Performance Appraisal"
                  count={appraisalCount}
                  percentage={{color: "success"}}
                />
              </MDBox>
            </Grid>
          </Grid>
        )}

        {/* ✅ Draggable grid — DraggableGridItem now receives orderMap, defaultOrder, swapOrder as props */}
        <MDBox mt={2}>
          <Grid
            container
            spacing={2}
            onDragOver={e => {
              const edge = 80;
              const y = e.clientY;
              const vh = window.innerHeight;
              if (y < edge) window.scrollBy({top: -20, behavior: "auto"});
              else if (y > vh - edge) window.scrollBy({top: 20, behavior: "auto"});
            }}
          >
            {(userType === "Admin" ||
              userType === "Manager" ||
              userType === "IT_Admin_Manager") && (
              <DraggableGridItem
                id="probation"
                gridProps={{xs: 12, md: 6, lg: 4}}
                orderMap={orderMap}
                defaultOrder={defaultOrder}
                swapOrder={swapOrder}
              >
                <MDBox mb={2}>
                  <ProbationEndList probationData={probationData} />
                </MDBox>
              </DraggableGridItem>
            )}

            {userType === "Admin" && (
              <DraggableGridItem
                id="expectedJoinings"
                gridProps={{xs: 12, md: 6, lg: 4}}
                orderMap={orderMap}
                defaultOrder={defaultOrder}
                swapOrder={swapOrder}
              >
                <MDBox mb={2}>
                  <ExpectedJoiningsList joiningData={joiningData} />
                </MDBox>
              </DraggableGridItem>
            )}

            {(userType === "Admin" ||
              userType === "Manager" ||
              userType === "IT_Admin_Manager") && (
              <DraggableGridItem
                id="pip"
                gridProps={{xs: 12, md: 6, lg: 4}}
                orderMap={orderMap}
                defaultOrder={defaultOrder}
                swapOrder={swapOrder}
              >
                <MDBox mb={2}>
                  <PIPList pipData={pipData} />
                </MDBox>
              </DraggableGridItem>
            )}

            {userType === "Admin" && (
              <DraggableGridItem
                id="reportingNotSet"
                gridProps={{xs: 12, md: 6, lg: 4}}
                orderMap={orderMap}
                defaultOrder={defaultOrder}
                swapOrder={swapOrder}
              >
                <MDBox mb={2}>
                  <ReportingManagerNotSetList reportingData={reportingData} />
                </MDBox>
              </DraggableGridItem>
            )}

            {(userType === "Admin" ||
              userType === "Manager" ||
              userType === "IT_Admin_Manager") && (
              <DraggableGridItem
                id="employeeOnLeaves"
                gridProps={{xs: 12, md: 6, lg: 4}}
                orderMap={orderMap}
                defaultOrder={defaultOrder}
                swapOrder={swapOrder}
              >
                <MDBox mb={2}>
                  <EmployeeOnLeaves employeeOnLeaves={employeeOnLeaves} />
                </MDBox>
              </DraggableGridItem>
            )}

            {userType === "Admin" && (
              <>
                <DraggableGridItem
                  id="birthday"
                  gridProps={{xs: 12, md: 6, lg: 4}}
                  orderMap={orderMap}
                  defaultOrder={defaultOrder}
                  swapOrder={swapOrder}
                >
                  <MDBox mb={2}>
                    <BirthDayList birthDayData={birthDayData} month={month} setMonth={setMonth} />
                  </MDBox>
                </DraggableGridItem>

                <DraggableGridItem
                  id="documentsPending"
                  gridProps={{xs: 12, md: 6, lg: 4}}
                  orderMap={orderMap}
                  defaultOrder={defaultOrder}
                  swapOrder={swapOrder}
                >
                  <MDBox mb={2}>
                    <DocumentsPendingList documentsPending={documentsPending} />
                  </MDBox>
                </DraggableGridItem>

                <DraggableGridItem
                  id="uploadImgPending"
                  gridProps={{xs: 12, md: 6, lg: 4}}
                  orderMap={orderMap}
                  defaultOrder={defaultOrder}
                  swapOrder={swapOrder}
                >
                  <MDBox mb={2}>
                    <UploadImgPendingList uploadImgPending={uploadImgPending} />
                  </MDBox>
                </DraggableGridItem>

                <DraggableGridItem
                  id="employeeComposition"
                  gridProps={{xs: 12, md: 6, lg: 4}}
                  orderMap={orderMap}
                  defaultOrder={defaultOrder}
                  swapOrder={swapOrder}
                >
                  <MDBox mb={2}>
                    <EmployeeComposition />
                  </MDBox>
                </DraggableGridItem>

                <DraggableGridItem
                  id="billableNonBillable"
                  gridProps={{xs: 12, md: 6, lg: 4}}
                  orderMap={orderMap}
                  defaultOrder={defaultOrder}
                  swapOrder={swapOrder}
                >
                  <MDBox>
                    <BillableNonBillable />
                  </MDBox>
                </DraggableGridItem>

                <DraggableGridItem
                  id="workAnniversary"
                  gridProps={{xs: 12, md: 6, lg: 4}}
                  orderMap={orderMap}
                  defaultOrder={defaultOrder}
                  swapOrder={swapOrder}
                >
                  <MDBox mb={2}>
                    <UpcomingWorkAnniversary
                      workAnniversaryData={workAnniversaryData5}
                      milestoneYears={5}
                      title="Upcoming 5 Year Work Anniversaries"
                    />
                  </MDBox>
                </DraggableGridItem>

                <DraggableGridItem
                  id="workAnniversary10"
                  gridProps={{xs: 12, md: 6, lg: 4}}
                  orderMap={orderMap}
                  defaultOrder={defaultOrder}
                  swapOrder={swapOrder}
                >
                  <MDBox mb={2}>
                    <UpcomingWorkAnniversary
                      workAnniversaryData={workAnniversaryData10}
                      milestoneYears={10}
                      title="Upcoming 10 Year Work Anniversaries"
                    />
                  </MDBox>
                </DraggableGridItem>
              </>
            )}

            {/* ✅ memoizedCalendar — stable reference, APIs won't fire on burger click */}
            <DraggableGridItem
              id="calendarBlock"
              gridProps={{xs: 12}}
              orderMap={orderMap}
              defaultOrder={defaultOrder}
              swapOrder={swapOrder}
            >
              {memoizedCalendar}
            </DraggableGridItem>
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
